// ManageMembership.jsx
import React, { useState } from "react";
import { BoxContainer } from "../containers/boxContainer/boxContainer";
import styles from "./ManageMembership.module.css";
import ManageMembershipOptions from "./ManageMembershipOptions";
import { connect } from "react-redux";
import { STATUSES } from "../../serverVariables/statuses";
import { PrimaryButton } from "../buttons/buttons";

const ManageMembership = ({ user }) => {
  const [showOptions, setShowOptions] = useState(false);
  const handleToggle = () => setShowOptions((prev) => !prev);

  // 1) find the matching [key, id] entry
  const entry = Object.entries(STATUSES).find(
    ([key, id]) => id === user.user_status_id
  );

  // 2) safely extract key or fallback
  const statusKey = entry ? entry[0] : "";

  // 3) format: replace underscores, capitalize first letter
  const statusLabel = statusKey
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  if (showOptions) {
    return <ManageMembershipOptions onClose={handleToggle} />;
  }

  return (
    <BoxContainer className={styles.card}>
      <div className={styles.header}>
        <h2>Membership</h2>
      </div>

      <div className={styles.content}>
        <div className={styles.infoRow}>
          <span className={styles.label}>Current Plan:</span>
          <span className={styles.value}>{user.organization.name}</span>
        </div>
        <div className={styles.infoRow}>
          <span className={styles.label}>Member Status:</span>
          <span className={styles.value}>{statusLabel}</span>
        </div>
      </div>

      <div className={styles.manageButton}>
        <PrimaryButton
          type="button"
          onClick={handleToggle}
          className={styles.saveButton}
        >
          {showOptions ? "Close Options" : "Manage Membership"}
        </PrimaryButton>
      </div>
    </BoxContainer>
  );
};

const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(ManageMembership);
